/*
 * @Author: YH000644 weirongwei@danghuan.com
 * @Date: 2024-12-03 12:07:17
 * @LastEditors: YH000644 weirongwei@danghuan.com
 * @LastEditTime: 2024-12-03 12:11:44
 * @FilePath: \eu-eswop-official-site\src\locales\index.js
 * @Description:
 */

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ElementUI from 'element-ui'

// 引入自定义语言配置
import zh from './lang/zh.js'
import en from './lang/en.js'
import es from './lang/es.js'
import fr from './lang/fr.js'
import de from './lang/de.js' // (德语)
import da from './lang/da.js' // (丹麦语)
import nl from './lang/nl.js' // (荷兰语)
import pl from './lang/pl.js' // (波兰语)
import fi from './lang/fi.js' // (芬兰语)
import sv from './lang/sv.js' // (瑞典语)
import it from './lang/it.js' // (意大利语)


// 引入UI框架语言配置---elementui
import iviewZH from 'element-ui/lib/locale/lang/zh-CN.js'
import iviewEN from 'element-ui/lib/locale/lang/en.js'
import iviewES from 'element-ui/lib/locale/lang/es.js'
import iviewFR from 'element-ui/lib/locale/lang/fr.js'
import iviewDE from 'element-ui/lib/locale/lang/de.js'
// Element UI 可能没有所有语言的包，对于没有的语言可以使用英文作为fallback
import iviewDA from 'element-ui/lib/locale/lang/da.js'
import iviewNL from 'element-ui/lib/locale/lang/nl.js'
import iviewPL from 'element-ui/lib/locale/lang/pl.js'
import iviewFI from 'element-ui/lib/locale/lang/fi.js'
import iviewSV from 'element-ui/lib/locale/lang/sv-SE.js'
import iviewIT from 'element-ui/lib/locale/lang/it.js'

const hash = window.location.hash; // "#/page?nationCode=CH&channelId=114030"
const queryString = hash.split('?')[1]; // "nationCode=CH&channelId=114030"
const urlParams = new URLSearchParams(queryString);

// 优先使用 lang 参数，如果没有则使用 nationCode 参数，默认使用 'es'
const langParam = urlParams.get('lang') || urlParams.get('nationCode') || 'en';

console.log("langParam", langParam)

// 简化：只取 langParam 中下划线前的部分作为语言代码
const getLanguageFromParam = (param) => {
  if (!param) return 'es';
  
  // 如果包含下划线，取第一部分
  if (param.includes('_')) {
    return param.split('_')[0];
  }
  
  // 如果不包含下划线，检查是否是已知的语言代码
  const knownLanguages = ['zh', 'en', 'es', 'fr', 'de', 'da', 'nl', 'pl', 'fi', 'sv', 'it'];
  if (knownLanguages.includes(param.toLowerCase())) {
    return param.toLowerCase();
  }
  
  // 默认使用西班牙语
  return 'es';
};

// 确定最终使用的语言
const finalLang = getLanguageFromParam(langParam);

console.log("finalLang", finalLang)

Vue.use(VueI18n)

const localeMapping = {
  zh: {
    name: 'ZH',
    value: 'zh',
    langFile: zh,
    iViewLangeFile: iviewZH,
    acceptLanguage: 'zh_CN',
  }, 
  en: {
    name: 'EN',
    value: 'en',
    langFile: en,
    iViewLangeFile: iviewEN,
    acceptLanguage: 'en_US',
  },
  es: {
    name: 'ES',
    value: 'es',
    langFile: es,
    iViewLangeFile: iviewES,
    acceptLanguage: 'es_ES',
  },
  fr: {
    name: 'FR',
    value: 'fr',
    langFile: fr,
    iViewLangeFile: iviewFR,
    acceptLanguage: 'fr_FR',
  },
  de: {
    name: 'DE',
    value: 'de',
    langFile: de,
    iViewLangeFile: iviewDE,
    acceptLanguage: 'de_DE',
  },
  da: {
    name: 'DA',
    value: 'da',
    langFile: da,
    iViewLangeFile: iviewDA,
    acceptLanguage: 'da_DK',
  },
  nl: {
    name: 'NL',
    value: 'nl',
    langFile: nl,
    iViewLangeFile: iviewNL,
    acceptLanguage: 'nl_NL',
  },
  pl: {
    name: 'PL',
    value: 'pl',
    langFile: pl,
    iViewLangeFile: iviewPL,
    acceptLanguage: 'pl_PL',
  },
  fi: {
    name: 'FI',
    value: 'fi',
    langFile: fi,
    iViewLangeFile: iviewFI,
    acceptLanguage: 'fi_FI',
  },
  sv: {
    name: 'SV',
    value: 'sv',
    langFile: sv,
    iViewLangeFile: iviewSV,
    acceptLanguage: 'sv_SE',
  },
  it: {
    name: 'IT',
    value: 'it',
    langFile: it,
    iViewLangeFile: iviewIT,
    acceptLanguage: 'it_IT',
  }
};

const defaultLang = finalLang;
const lang = finalLang;
const isES = lang === 'es';

console.log(lang)

// 设置后台语言的请求头
const customRequestHeader = {
  'Accept-Language': localeMapping[lang]?.acceptLanguage || 'en_US',
  'name': localeMapping[lang]?.name || 'EN'
};
const i18n = new VueI18n({
  locale: lang
})

// 确保语言在 localeMapping 中存在，如果不存在则使用英语
const selectedLang = localeMapping[lang] ? lang : 'EN';
i18n.setLocaleMessage(selectedLang, Object.assign(localeMapping[selectedLang]?.langFile, localeMapping[selectedLang]?.iViewLangeFile))

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

const vm = new Vue({ i18n })

// 切换语言方法
Vue.prototype.$toggleLang = (lang = defaultLang) => {
  sessionStorage.setItem('lang', lang)
  window.location.reload()
}

if (window.location.hostname !== 'localhost') {
  // 本地开发展示中文
  delete localeMapping.zh
}
export {
  i18n,
  localeMapping,
  lang,
  vm,
  isES,
  customRequestHeader
}